import { useCallback, useEffect, useState } from 'react';
import { v1 as uuid } from 'uuid';

import type { CustomerBalanceTransactionDrawerState } from '../types';
import { getInitialState } from '../utils';

export interface UseCustomerBalanceTransactionStateProps {
  formDefaults?: Partial<CustomerBalanceTransactionDrawerState>;
}

export function useCustomerBalanceTransactionState({ formDefaults }: UseCustomerBalanceTransactionStateProps) {
  // Initialize state properly to prevent flashing of old data
  const [drawerState, setDrawerState] = useState<CustomerBalanceTransactionDrawerState>(getInitialState(formDefaults));

  const [confirmText, setConfirmText] = useState('');

  // Update state when formDefaults change (allows updating drawer while it's already open)
  useEffect(() => {
    // Reset state when drawer is opened
    const initialState = getInitialState(formDefaults);
    setDrawerState(initialState);
    setConfirmText('');
  }, [formDefaults]);

  const updateDrawerState = useCallback((updates: Partial<CustomerBalanceTransactionDrawerState>) => {
    setDrawerState((prev: CustomerBalanceTransactionDrawerState) => ({ ...prev, ...updates }));
  }, []);

  const handleGenerateExternalID = useCallback(() => {
    updateDrawerState({ externalID: uuid() });
  }, [updateDrawerState]);

  const isStateInitialized = drawerState.externalID !== undefined;

  return {
    drawerState,
    confirmText,
    setConfirmText,
    updateDrawerState,
    handleGenerateExternalID,
    isStateInitialized,
  };
}
